import '../css/app.scss';
import './script/neto.js';
import { addEvent, appHeight } from './script/utils';
appHeight();
addEvent();

import popupCalls from './script/popupCalls';
import searchInput from './script/searchInput';
import mobMenu from './script/mobMenu';
import headerHoverPopups from './script/headerHoverPopups';
import megamenu from './script/megamenu';
import sliders from './script/slider';
import stickyHeader from './script/stickyHeader';
import readMore from './script/readmore';
import accordian from './script/accordian';
import trade from './script/trade';
import showMoreFilters from './script/filterShowmore';
import stickyFilters from './script/stickyFilters';
import scrollCart from './script/cartLine';
import tabs from './script/tabs';

popupCalls.init();
searchInput.init();
mobMenu.init();
headerHoverPopups.init();
megamenu.init();
sliders.init();
stickyHeader.init();
readMore.init();
accordian.init();
// trade.init();
showMoreFilters.init();
stickyFilters.init();
tabs.init();
scrollCart.init();